"use client"

import { DefaultImage } from "@/lib/external-components"
import { toImageSrc } from "@/lib/utils"
import Image from "next/image"

interface AboutUsSectionContentProps {
  title: string
  description: string
  floorPlanImage: string
  logo: string
  mainImage: string
}

export const AboutUsSectionContent = ({
  title,
  description,
  floorPlanImage,
  logo,
  mainImage,
}: AboutUsSectionContentProps) => {
  const floorPlanUrl = floorPlanImage ? toImageSrc(floorPlanImage) : null
  const logoUrl = logo ? toImageSrc(logo) : null
  const mainImageUrl = mainImage ? toImageSrc(mainImage) : DefaultImage

  return (
    <div className="relative w-full px-[0.9375rem] sm:px-0">
      {/* Container với max-width 1298px */}
      <div className="relative w-full max-w-[1298px] mx-auto min-h-[600px] sm:min-h-auto">
        {/* Title - Ở trên cùng, độc lập */}
        {title && (
          <div className="w-full sm:w-[530.84px] pb-[2rem] sm:pb-[1.5rem]">
            <h2 className="text-xl sm:text-2xl font-bold leading-[1.625rem] sm:leading-[1.875rem] text-[#333333] uppercase text-left">
              {title}
            </h2>
          </div>
        )}

        {/* Description - Ngang với Floor Plan */}
        {description && (
          <div className="w-full sm:w-[529.11px]">
            <p className="text-sm sm:text-base font-normal leading-[1.35625rem] sm:leading-[1.55rem] pt-0 pb-[3.5rem] sm:py-[0.75rem] text-[#333333] text-left">
              {description}
            </p>
          </div>
        )}

        {/* Hình 3: Main Image - Trong cột trái: 531x354, absolute position */}
        {mainImageUrl && (
          <div className="relative sm:absolute sm:top-[260px] w-calc(100vw - 30px) sm:w-[531px] aspect-[5472/3648] sm:h-[354px] overflow-hidden mt-3 sm:mt-0">
            <Image
              src={mainImageUrl}
              alt="About Us"
              fill
              className="object-cover"
              sizes="(max-width: 640px) 100vw, 531px"
            />
          </div>
        )}

        {/* Cột phải: 757.16px - Floor Plan ngang với Description */}
        <div className="hidden sm:block absolute top-[3.5rem] left-[540.84px] w-[757.16px]">
          {floorPlanUrl && (
            <div className="relative w-full pl-0 sm:pl-[2rem]">
              <div className="relative w-[715px] h-[440.5px]">
                <Image src={floorPlanUrl} alt="Floor Plan" fill className="object-contain" sizes="715px" />
              </div>
            </div>
          )}
        </div>

        {/* Mobile: Floor Plan hiển thị dưới text */}
        {floorPlanUrl && (
          <div className="block sm:hidden relative w-full mt-[0.625rem]">
            <div className="relative w-calc(100vw - 30px) aspect-[784/483]">
              <Image src={floorPlanUrl} alt="Floor Plan" fill className="object-contain" sizes="343px" />
            </div>
          </div>
        )}

        {/* Hình 2: Logo - Ở giữa 2 cột (absolute position) */}
        {logoUrl && (
          <div className="hidden sm:block absolute top-[46%] left-[570px] -translate-x-1/2 z-50 pointer-events-none w-[258px] max-w-[258px]">
            <div className="relative w-full h-[120px] pointer-events-auto">
              <Image src={logoUrl} alt="Logo" fill className="object-contain" sizes="350px" />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
